<template>
  <div class="newJournal-view">
    <div class="section-header">
      <div class="section-header-row">
        <h1>
          {{ $t("newJournal.journal") }}
        </h1>
        <button type="button" class="filter-btn" @click="filterDrawerOpen = true">
          {{ $t("newJournal.filter") }}
          <v-icon small class="ml-2">fa-regular fa-filter</v-icon>
        </button>
      </div>
      <!-- <ul class="conventions ml-auto">
        <li v-for="(con, index) in conventions" :key="index" :class="con.class">
          <v-icon class="icon" x-small icon>fa-circle</v-icon>{{ con.name }}
        </li>
      </ul> -->
    </div>
    <div class="old-filters">
      <OverallFilters ref="filters"></OverallFilters>
    </div>
    <JournalFiltersDrawer
      v-model="filterDrawerOpen"
      :filter-state="filterSelections"
      :default-filter-state="defaultFilterSelections"
      :show-clear="filtersAppliedOnce && hasActiveFilters"
      :labels="filterLabels"
      :period-options="periodOptions"
      :account-options="accountOptions"
      :asset-options="assetOptions"
      :side-options="sideOptions"
      :result-options="resultOptions"
      :mood-options="moodOptions"
      :strategy-options="strategyOptions"
      :dates="dates"
      @apply="onApplyFilters"
      @clear="onClearFilters"
    />
    <div>
      <div class="section-ratios mt-10">
        <div class="highlights-header">
          <h2>{{ $t("newJournal.highlight") }}</h2>
          <p class="highlights-trades-count">
            {{ $t("newJournal.totalTradesSummary", { count: totalTrades }) }}
          </p>
        </div>
        <div class="ratios-container">
          <v-col v-for="(ratio, index) in ratios" :key="'ratio-col-' + index" lg="2" md="3" sm="4" cols="6"
            :class="'desktop ' + (index == 0 || index == 5 ? 'pl-0 ' : ' ') + (index == 4 || index == 9 ? 'pr-0' : '')">
            <RatioCard
              :key="index"
              :chip="ratio.chip"
              :mainText="ratio.mainText"
              :subText="ratio.subText"
              :appColor="ratio.appColor"
              :featured="ratio.featured"
              :tooltip="ratio.tooltip"
            />
          </v-col>

          <!-- En pantallas pequeñas, muestra las tarjetas en un carrusel -->
          <div class="carousel-container mobile col-12 d-flex justify-content-center d-none d-sm-block">
            <v-carousel show-arrows hide-delimiters height="13vh" cycle>
              <v-carousel-item v-for="(ratio, index) in ratios" :key="'ratio-col-' + index">
                <RatioCard
                  :key="index"
                  :chip="ratio.chip"
                  :mainText="ratio.mainText"
                  :subText="ratio.subText"
                  :appColor="ratio.appColor"
                  :featured="ratio.featured"
                  :tooltip="ratio.tooltip"
                  class="ratio-card ratio-card-mobile"
                />
              </v-carousel-item>
            </v-carousel>
          </div>
        </div>
      </div>
      <div>
        <div class="section-tabs  mt-12">
          <!-- <h2>{{ $t("detailed") }}</h2> -->
          <Tabs class="mt-3" :newTrades="newTrades" :tabs="tabs" />
        </div>
      </div>
      <v-overlay :value="overlay" :dark="false">
        <AddTrade @closeOverlay="overlay = false" @tradesLimitReached="tradesLimitReached" @newTrade="newTrade" />
      </v-overlay>
      <v-overlay :value="overlayJournalModes" :dark="false">
        <JournalModes @importAdding="importAdding" @manuallyAdding="manuallyAdding"
          @closeWindow="overlayJournalModes = false" />
      </v-overlay>
      <v-overlay v-model="overlayUpgradeToPro" :dark="false">
        <UpgradeToPro :message="messageUpgradeToPro" @closeWindow="closeOverlayUpgradeToPro" />
      </v-overlay>
      <v-overlay :dark="false" :value="overlayImportTrades">
        <ImportTrades @closeImport="overlayImportTrades = false" />
      </v-overlay>
    </div>
  </div>
</template>
<script>
import Moods from "../moods";
import RatioCard from "../components/RatioCard.vue";
import Tabs from "../../../components/Tabs.vue";
import OverallFilters from "../components/OverallFilters.vue";
import JournalFiltersDrawer from "../components/JournalFiltersDrawer.vue";
import Repository from "../../../repositories/journal";
import AddTrade from "../AddTrade.vue";
import JournalModes from "../components/JournalModes.vue";
import UpgradeToPro from "../../../components/UpgradeToPro.vue";
import ImportTrades from "../components/ImportTrades.vue";
import BrokerAccountRepository from "../../../repositories/brokerAccount";
import { mapMutations } from "vuex";

const PERIOD_KEYS = ["week", "month", "60days", "90days", "customPeriod"];
const DEFAULT_PERIOD = "week";
const I18N_NS = "newJournal";

function createDefaultFilterSelections() {
  return {
    month: DEFAULT_PERIOD,
    accounts: null,
    assets: null,
    sides: null,
    results: null,
    moods: null,
    strategies: null,
  };
}

function cloneFilterSelections(state) {
  return {
    month: state.month || DEFAULT_PERIOD,
    accounts: state.accounts ? [...state.accounts] : null,
    assets: state.assets ? [...state.assets] : null,
    sides: state.sides ? [...state.sides] : null,
    results: state.results ? [...state.results] : null,
    moods: state.moods ? [...state.moods] : null,
    strategies: state.strategies ? [...state.strategies] : null,
  };
}

function hasNonDefaultFilters(state, dates = []) {
  const month = state.month || DEFAULT_PERIOD;
  if (month !== DEFAULT_PERIOD) {
    return true;
  }
  if (state.accounts && state.accounts.length) {
    return true;
  }
  if (state.assets && state.assets.length) {
    return true;
  }
  if (state.sides && state.sides.length) {
    return true;
  }
  if (state.results && state.results.length) {
    return true;
  }
  if (state.moods && state.moods.length) {
    return true;
  }
  if (state.strategies && state.strategies.length) {
    return true;
  }
  if (month === "customPeriod" && dates.length === 2) {
    return true;
  }
  return false;
}

export default {
  name: "NewJournal",
  components: {
    RatioCard,
    Tabs,
    OverallFilters,
    JournalFiltersDrawer,
    JournalModes,
    AddTrade,
    UpgradeToPro,
    ImportTrades,
  },
  created() {
    this.filterSelections = createDefaultFilterSelections();
  },
  mounted() {
    this.trades = this.$store.state.book.trades;
    this.updateFilters();
    this.init();
  },
  computed: {
    periodOptions() {
      return PERIOD_KEYS.map((key) => ({
        value: key,
        label: this.$t(`${I18N_NS}.${key}`),
      }));
    },
    accountOptions() {
      const seen = new Set();
      return this.$store.state.user.brokerAccounts
        .filter((acc) => {
          if (seen.has(acc.id)) {
            return false;
          }
          seen.add(acc.id);
          return true;
        })
        .map((acc) => ({
          value: acc.id,
          label: acc.identifier
            ? `${acc.identifier} ~ ${acc.broker.name.substring(0, 10)}...`
            : acc.broker.name,
        }));
    },
    assetOptions() {
      return this.$store.state.user.assets.map((asset) => ({
        value: asset.assetName,
        label: asset.assetName,
      }));
    },
    sideOptions() {
      return this.$store.state.sides.map((side) => ({
        value: side,
        label: side,
      }));
    },
    resultOptions() {
      return this.$store.state.results.map((result) => ({
        value: result,
        label: result,
      }));
    },
    moodOptions() {
      return Moods.map((m) => ({
        value: m[this.$i18n.locale],
        label: m[this.$i18n.locale],
      }));
    },
    strategyOptions() {
      return this.$store.state.user.strategies.map((s) => ({
        value: s.name,
        label: s.name,
      }));
    },
    filterLabels() {
      return {
        filterBy: this.$t(`${I18N_NS}.filterBy`),
        selectAll: this.$t(`${I18N_NS}.selectAll`),
        applyFilter: this.$t(`${I18N_NS}.applyFilter`),
        clearFilters: this.$t(`${I18N_NS}.clearFilters`),
        time: this.$t(`${I18N_NS}.time`),
        accounts: this.$t(`${I18N_NS}.accounts`),
        assets: this.$t(`${I18N_NS}.assets`),
        sides: this.$t(`${I18N_NS}.sides`),
        results: this.$t(`${I18N_NS}.results`),
        moods: this.$t(`${I18N_NS}.moods`),
        strategies: this.$t(`${I18N_NS}.strategies`),
        selectedPeriod: this.$t(`${I18N_NS}.selectedPeriod`),
        customPeriod: this.$t(`${I18N_NS}.customPeriod`),
      };
    },
    conventions() {
      return [
        { name: this.$t(`${I18N_NS}.profit`), class: "green" },
        { name: this.$t(`${I18N_NS}.loss`), class: "red" },
        { name: this.$t(`${I18N_NS}.normal`), class: "black" },
      ];
    },
    tabs() {
      return [
        {
          name: this.$t(`${I18N_NS}.trades`),
          base: "journal",
          path: "data",
          icon: "fa-list",
        },
        {
          name: this.$t(`${I18N_NS}.statics`),
          base: "journal",
          path: "stats",
          icon: "fa-chart-simple",
        },
      ];
    },
    defaultFilterSelections() {
      return createDefaultFilterSelections();
    },
    hasActiveFilters() {
      return hasNonDefaultFilters(this.filterSelections, this.dates);
    },
  },
  methods: {
    ...mapMutations(["setTradesPageable", "setBrokerAccounts"]),
    async init(){
      await BrokerAccountRepository.allBrokerAccountsOfUser().then((response) => {
        this.setBrokerAccounts(response.data);
      });
    },
    onApplyFilters(appliedState) {
      this.filterSelections = cloneFilterSelections(appliedState);
      this.filtersAppliedOnce = true;

      const isCustom = appliedState.month === "customPeriod";
      if (isCustom) {
        this.dates = appliedState.dates ? [...appliedState.dates] : [];
        this.confirmCustomDates();
      } else {
        this.dates = [];
        this.fullFromDateP = undefined;
        this.fullToDateP = undefined;
      }

      this.updateFilters();
      this.filterDrawerOpen = false;
    },
    onClearFilters() {
      this.resetFields();
      this.filtersAppliedOnce = false;
    },
    isCustomPeriod(month) {
      return month === "customPeriod";
    },
    parseLocalDate(dateValue) {
      if (!dateValue) {
        return null;
      }
      if (dateValue instanceof Date) {
        return new Date(
          dateValue.getFullYear(),
          dateValue.getMonth(),
          dateValue.getDate(),
          0,
          0,
          0
        );
      }
      const [year, month, day] = String(dateValue)
        .split("T")[0]
        .split("-")
        .map(Number);
      return new Date(year, month - 1, day, 0, 0, 0);
    },
    normalizeDateRange(dates) {
      if (!dates || dates.length !== 2) {
        return null;
      }
      const start = this.parseLocalDate(dates[0]);
      const end = this.parseLocalDate(dates[1]);
      if (!start || !end) {
        return null;
      }
      return start <= end ? [start, end] : [end, start];
    },
    formatLocalDate(date) {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");
      return `${year}-${month}-${day}`;
    },
    getPresetFromDate(month, referenceDate) {
      const fromDate = new Date(
        referenceDate.getFullYear(),
        referenceDate.getMonth(),
        referenceDate.getDate(),
        0,
        0,
        0
      );
      switch (month) {
        case "week":
          fromDate.setDate(fromDate.getDate() - 7);
          break;
        case "month":
          fromDate.setDate(fromDate.getDate() - 30);
          break;
        case "60days":
          fromDate.setDate(fromDate.getDate() - 60);
          break;
        case "90days":
          fromDate.setDate(fromDate.getDate() - 90);
          break;
        default:
          fromDate.setDate(fromDate.getDate() - 7);
      }
      return fromDate;
    },
    buildFilterParams() {
      const month = this.filterSelections.month || DEFAULT_PERIOD;
      const isCustom = this.isCustomPeriod(month);
      const today = new Date();
      const referenceDate = new Date(
        today.getFullYear(),
        today.getMonth(),
        today.getDate(),
        0,
        0,
        0
      );
      let fullFromDate;
      let fullToDate;

      if (isCustom) {
        if (!this.fullFromDateP || !this.fullToDateP) {
          fullToDate = referenceDate;
          fullFromDate = this.getPresetFromDate("week", referenceDate);
        } else {
          fullFromDate = this.parseLocalDate(this.fullFromDateP);
          fullToDate = this.parseLocalDate(this.fullToDateP);
        }
      } else {
        fullToDate = referenceDate;
        fullFromDate = this.getPresetFromDate(month, referenceDate);
      }

      const toDateForApi = new Date(fullToDate);
      toDateForApi.setDate(toDateForApi.getDate() + 1);

      let moodsKey = Moods.map((m) => m.key);
      if (this.filterSelections.moods && this.filterSelections.moods.length) {
        moodsKey = this.filterSelections.moods.map(
          (moodLabel) =>
            Moods.find((mood) => mood[this.$i18n.locale] === moodLabel).key
        );
      }

      const sideSelection = this.filterSelections.sides;
      const side =
        sideSelection && sideSelection.length === 1
          ? sideSelection[0].trim().toUpperCase()
          : "All";

      const resultSelection = this.filterSelections.results;
      const result =
        resultSelection && resultSelection.length === 1
          ? resultSelection[0]
          : "All";

      const assetSelection = this.filterSelections.assets;
      const asset =
        assetSelection && assetSelection.length
          ? assetSelection.map(
              (val) =>
                this.$store.state.user.assets.find(
                  (item) => val === item.assetName
                ).ticker
            )
          : this.$store.state.user.assets.map((item) => item.ticker);

      const accountSelection = this.filterSelections.accounts;
      const brokerAccount =
        accountSelection && accountSelection.length
          ? accountSelection.map((val) => Number(val))
          : this.$store.state.user.brokerAccounts.map((acc) => acc.id);

      const strategySelection = this.filterSelections.strategies;
      const allStrategies = !(
        strategySelection && strategySelection.length
      );
      const strategy =
        strategySelection && strategySelection.length
          ? strategySelection.map(
              (val) =>
                this.$store.state.user.strategies.find((s) => s.name === val).id
            )
          : ["-1"];

      return {
        allStrategies,
        fromDate: fullFromDate,
        toDate: toDateForApi,
        side,
        mood: moodsKey,
        asset,
        brokerAccount,
        result,
        strategy,
      };
    },
    updateFilters() {
      const params = this.buildFilterParams();
      this.$refs.filters.setFilterMade(true);
      this.$refs.filters.setCurrentFilter(params);
      if (this.$route.name == "stats") {
        this.setTradesPageable(null);
      }
      this.$refs.filters.callFilter(params);

      Repository.analyticsSummary({
        allStrategies: params.allStrategies,
        fromDate: params.fromDate,
        toDate: params.toDate,
        side: params.side,
        moods: params.mood,
        assets: params.asset,
        brokerAccounts: params.brokerAccount,
        result: params.result,
        strategies: params.strategy,
      }).then((response) => {
        if (response.status < 400) {
          let analytics = response.data.content[0];
          this.totalTrades = analytics.trades || 0;
          let duration = new Date(analytics.averageDuration * 1000)
            .toISOString()
            .substring(11, 19)
            .split(":");
          this.ratios = [
            {
              chip: analytics.netProfit >= 0 ? this.$t(`${I18N_NS}.profitable`) : "",
              mainText:
                (analytics.netProfit >= 0 ? "+$" : "-$") +
                Math.abs(analytics.netProfit).toFixed(0),
              subText: this.$t(`${I18N_NS}.netProfit`),
              appColor: analytics.netProfit >= 0 ? "success" : "error",
              tooltip: { text: this.$t(`${I18N_NS}.ratioTooltips.netProfit`) },
            },
            {
              chip: undefined,
              featured: true,
              mainText:
                "+$" +
                Math.abs(Number(analytics.profitBestTrade)).toLocaleString(undefined, { maximumFractionDigits: 0 }),
              subText: this.$t(`${I18N_NS}.bestTrade`),
              appColor: "success",
              tooltip: { text: this.$t(`${I18N_NS}.ratioTooltips.bestTrade`) },
            },
            {
              chip: undefined,
              mainText:
                "-$" +
                Math.abs(Number(analytics.profitWorstTrade)).toLocaleString(undefined, { maximumFractionDigits: 0 }),
              subText: this.$t(`${I18N_NS}.worstTrade`),
              appColor: "error",
              tooltip: { text: this.$t(`${I18N_NS}.ratioTooltips.worstTrade`) },
            },
            {
              chip: undefined,
              mainText: "1:" + analytics.riskReward.toFixed(2).toString(),
              subText: this.$t(`${I18N_NS}.riskReward`),
              appColor: "neutral",
              tooltip: { text: this.$t(`${I18N_NS}.ratioTooltips.riskReward`) },
            },
            {
              chip: undefined,
              mainText: "$" + analytics.commissions.toFixed(2).toString(),
              subText: this.$t(`${I18N_NS}.commissions`),
              appColor: "neutral",
              tooltip: { text: this.$t(`${I18N_NS}.ratioTooltips.commissions`) },
            },
            // {
            //   chip: undefined,
            //   mainText: analytics.swisetRatio.toFixed(2),
            //   subText: "Swiset Ratio",
            //   appColor: analytics.swisetRatio >= 1 ? "success" : "error",
            // },
            // {
            //   chip: undefined,
            //   mainText: (analytics.winRate * 100).toFixed(2) + "%",
            //   subText: "Win Rate",
            //   appColor: "black",
            // },
            // {
            //   chip: undefined,
            //   mainText: analytics.profitFactor.toFixed(2).toString(),
            //   subText: "Profit Factor",
            //   appColor: analytics.profitFactor >= 1 ? "success" : "error",
            // },

            // {
            //   chip: undefined,
            //   mainText: analytics.trades.toString(),
            //   subText: "Total Trades",
            //   appColor: "black",
            // },
            // {
            //   chip: undefined,
            //   mainText:
            //     duration[0] + "h " + duration[1] + "m " + duration[2] + "s",
            //   subText: "Avg. Duration",
            //   appColor: "black",
            // },
          ];
        }
      });
      const nextQuery = {
        startDate: this.formatLocalDate(params.fromDate),
        endDate: this.formatLocalDate(
          new Date(params.toDate.getTime() - 24 * 60 * 60 * 1000)
        ),
      };
      const { startDate, endDate } = this.$route.query;
      if (
        startDate !== nextQuery.startDate ||
        endDate !== nextQuery.endDate
      ) {
        this.$router.replace({ query: nextQuery }).catch(() => {});
      }
    },
    resetFields() {
      this.filterSelections = createDefaultFilterSelections();
      this.dates = [];
      this.fullFromDateP = undefined;
      this.fullToDateP = undefined;
      this.updateFilters();
    },
    confirmCustomDates() {
      const range = this.normalizeDateRange(this.dates);
      if (!range) {
        return;
      }
      this.fullFromDateP = range[0];
      this.fullToDateP = range[1];
    },
    manuallyAdding() {
      this.overlayJournalModes = false;
      this.overlay = true;
    },
    importAdding() {
      if (this.$store.state.user.isPro) this.overlayJournalModes = false;
      this.importTradesOverlay();
    },
    importTradesOverlay() {
      if (!this.$store.state.user.isPro) {
        this.overlayUpgradeToPro = true;
        this.messageUpgradeToPro =
          "You cannot import trades. With Pro you can import historic trades from several platforms.";
      } else this.overlayImportTrades = true;
    },
    closeOverlayUpgradeToPro() {
      this.overlayUpgradeToPro = false;
    },
    newTrade() {
      this.overlay = false;
    },
    tradesLimitReached() {
      this.messageUpgradeToPro =
        "You reached the limit of trades for the month of this trade. With pro you can register unlimited trades.";
      this.overlayUpgradeToPro = true;
      this.overlay = false;
    },
    newTrades() {
      this.overlayJournalModes = true
    },
  },
  data() {
    return {
      fromDate: new Date(),
      toDate: new Date(),
      trades: [],
      dates: [],
      overlay: false,
      overlayJournalModes: false,
      overlayUpgradeToPro: false,
      fullFromDateP: undefined,
      messageUpgradeToPro: "",
      overlayImportTrades: false,
      fullToDateP: undefined,
      filterDrawerOpen: false,
      filtersAppliedOnce: false,
      filterSelections: createDefaultFilterSelections(),
      ratios: [],
      totalTrades: 0,
    };
  },
};
</script>
<style lang="scss">
.newJournal-view {
  display: flex;
  flex-direction: column;
  font-family: "Avenir";
  font-weight: 300;
  font-size: 16px;
  padding-top: 20px;

  .datesContainer {
    display: flex;
    flex-direction: column;
    justify-content: center;
    background-color: var(--v-mainWhite-base);
    border-radius: 10px;
    padding: 20px;
    color: var(--v-mainBlack-base) !important;

    .v-text-field {
      background-color: var(--v-baseBackground-base);
      color: var(--v-mainBlack-base) !important;
    }

    .v-date-picker {
      .primary {
        background-color: var(--v-mainBtnBackground-base) !important;
        color: var(--v-mainBlack-base) !important;
      }

      .theme--light.v-picker__body,
      .theme--dark.v-picker__body {
        background-color: var(--v-baseBackground-base) !important;
      }

      background-color: var(--v-baseBackground-base);
      color: var(--v-mainBlack-base) !important;

      .v-icon {
        color: var(--v-mainBlack-base) !important;
      }
    }
  }

  .old-filters {
    display: none;
  }

  .section-header {
    display: flex;
    flex-direction: column;
    width: 100%;
    margin-bottom: 8px;

    @media (max-width: 768px) {
      margin-left: 0px;
    }

    .section-header-row {
      display: flex;
      align-items: center;
      justify-content: space-between;
      width: 100%;
      margin-bottom: 12px;

      h1 {
        font-weight: 700;
        font-family: "Avenir", sans-serif;
        margin: 0;
        color: var(--v-darkGrey-base);
        font-size: 28px;
      }
    }

    .filter-btn {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      gap: 8px;
      padding: 8px 16px;
      border: none;
      border-radius: 8px;
      background: var(--v-buttonSecondary-base);
      color: var(--v-buttonSecondaryText-base) !important;
      font-family: "Avenir", sans-serif;
      font-size: 14px;
      font-weight: 600;
      cursor: pointer;
      transition: background 0.2s, color 0.2s;

      &:hover {
        background: var(--v-buttonSecondaryHover-base);
        color: var(--v-buttonSecondaryTextHover-base) !important;
      }

      .v-icon {
        color: inherit !important;
      }
    }

    .title-2 {
      font-weight: 700;
      font-family: "Avenir", sans-serif;
      margin: 0;
      padding-left: 0;
      padding-right: 0;
      color: var(--v-darkGrey-base);

      @media (max-width: 768px) {
        display: flex;
        justify-content: center;
      }
    }

    .conventions {
      list-style-type: none;
      display: flex;
      justify-content: flex-end;
      width: 100%;
      padding: 0;
      margin: 0;

      @media (max-width: 768px) {
        justify-content: center;
      }

      li {
        font-size: 16px;
        display: flex;
        font-style: normal;
        color: var(--v-mainBlack-base) !important;
        line-height: 1;
        background-color: transparent !important;
        align-items: center;
        margin-left: 50px;

        .icon {
          font-size: 18px;
          color: inherit !important;
          margin-right: 10px;
        }

        &.red {
          color: var(--v-darkRed-base) !important;
        }

        &.green {
          color: var(--v-darkGreen-base) !important;
        }
      }
    }
  }

  .title-3 {
    font-size: 17px;
    font-family: "Avenir", sans-serif;
    color: var(--v-darkGrey-base);
    margin-bottom: 10px;

    @media (max-width: 768px) {
      margin-left: auto;
      margin-right: auto;
      margin-top: 25px;
    }
  }

  .section-ratios {
    .highlights-header {
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: 16px;
      margin-bottom: 16px;
      flex-wrap: wrap;

      h2 {
        margin: 0;
      }
    }

    .highlights-trades-count {
      margin: 0;
      font-family: 'Avenir', sans-serif;
      font-size: 14px;
      font-weight: 400;
      color: #ababab;
      white-space: nowrap;
    }

    .ratios-container {
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;

      @media (min-width: 1264px) {
        .col-lg-2 {
          flex: 0 0 30%;
          max-width: 20%;
        }
      }
    }
  }

  @media (min-width: 600px) {
    .section-ratios {
      margin-top: 0px;
      /* Ajusta este valor según tus necesidades */
    }
  }

  .btn {
    margin-right: 5px;
    text-overflow: ellipsis;
    display: block;
    text-wrap: nowrap;
    overflow: hidden;
  }

  .v-btn {
    margin-left: 10px;

    &:first-of-type {
      .svg-icon {
        margin-right: 20px;
      }
    }

    .icon {
      color: inherit !important;
    }
  }

  @media (min-width: 600px) {
    .carousel-container {
      width: 100vw;
      padding-top: 10px;
      padding-bottom: 30px;
    }

    .mobile {
      display: none !important;
    }
  }

  @media (max-width: 599px) {
    .desktop {
      display: none;
    }
  }

  .v-window__prev,
  .v-window__next {
    background: transparent;
    padding: 0 0px;
  }

  .v-carousel__controls__item,
  .v-window__prev,
  .v-window__next {
    //opacity: 10% !important;
    display: none;
  }

  @media (min-width: 769px) {
    .mobile-button {
      display: none;
    }
  }

  .ratio-card-mobile {
    width: 85%;
    margin: auto;
    margin-left: 30px;
  }

  .sticky-section {
    position: sticky;
    background-color: var(--v-mainWhite-base);
    top: 0;
    z-index: 2;
    /* Ajusta el valor según sea necesario */
  }
}
</style>
